module.exports = __webpack_public_path__ + "img/ko.793c8ae2.svg";